import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Messages } from "primereact/messages";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";

import {
  ADD_CHANNELS_PACKAGE,
  DEL_CHANNELS_PACKAGE,
  UPDATE_CHANNELS_PACKAGE,
} from "../../../store/constants/serviceEndpoint";
import _ from "lodash";
import { axiosWithHeaders } from "../../../store/constants/axiosWrapper";
import * as enums from "../../../common/enum";
import Swal from "sweetalert2";

const initData = {
  name: "",
  description: "",
  channelId: 0,
  area: [],
  isDefault: false,
};

export default function ConfigChannelPackage({
  eventId,
  data = [],
  listArea = [],
  listChannel = [],
  onReloadData,
}) {
  // console.log(data, listArea, listChannel);
  const refMessage = useRef(null);

  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState(initData);
  const [loading, setLoading] = useState(false);

  const onCancel = (e) => {
    if (e) e.preventDefault();
    setVisible(false);
    setItem(initData);
  };

  // console.log(item);
  const checkData = (obj) => {
    for (var field in obj) {
      if (
        obj[field] === undefined ||
        obj[field] === null ||
        obj[field] === "" ||
        obj[field] === 0
      ) {
        switch (field) {
          case "Name":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng nhập tên suất !",
            });
            break;
          case "Description":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng nhập mô tả về suất!",
            });
            break;
          case "ChannelId":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng chọn kênh !",
            });
            break;
          case "AreaId":
            refMessage.current.show({
              severity: "error",
              summary: "Lỗi",
              detail: "Vui lòng chọn vùng !",
            });
            break;
          default:
            break;
        }
        return false;
      }
    }
    return true;
  };

  const onAddData = (e) => {
    e.preventDefault();

    let objAdd = {};
    objAdd.Name = item.name;
    objAdd.Description = item.description;
    objAdd.ChannelId = item.channelId;
    objAdd.AreaId = item.area.join(",");

    // console.log(objAdd);
    const check = checkData(objAdd);
    if (check) {
      objAdd.EventId = eventId;
      objAdd.isDefault = item.isDefault;
      objAdd.AreaId = item.area;

      axiosWithHeaders("post", ADD_CHANNELS_PACKAGE, objAdd)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              Swal.fire("Thông báo", "Thêm suất thành công", "success");
              setItem(null);
              setVisible(false);
              if (typeof onReloadData === "function") onReloadData(eventId);
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => {
          Swal.fire("Lỗi", err.toString(), "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onUpdateData = (e) => {
    e.preventDefault();
    let objUpdate = {};
    objUpdate.Name = item.name;
    objUpdate.Description = item.description;
    objUpdate.ChannelId = item.channelId;
    objUpdate.AreaId = item.area.join(",");
    const check = checkData(objUpdate);
    if (check) {
      objUpdate.EventId = eventId;
      objUpdate.isDefault = item.isDefault;
      objUpdate.AreaId = item.area;
      objUpdate.id = item.id;

      setLoading(true);
      axiosWithHeaders("post", UPDATE_CHANNELS_PACKAGE, objUpdate)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.status === enums.RESPONSE_OK
          ) {
            const { status, message } = response.data;
            if (status === enums.RESPONSE_OK) {
              Swal.fire("Thông báo", "Cập nhật thành công", "success");
              setItem(null);
              setVisible(false);
              if (typeof onReloadData === "function") onReloadData(eventId);
            } else {
              Swal.fire("Lỗi", message, "error");
            }
          }
        })
        .catch((err) => {
          Swal.fire("Lỗi", err.toString(), "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const footer = (
    <>
      {item && item.id ? (
        <Button
          label="Cập nhật"
          icon="pi pi-check"
          onClick={onUpdateData}
          className="p-button-raised"
          loading={loading}
        />
      ) : (
        <Button
          label="Xác nhận"
          icon="pi pi-check"
          onClick={onAddData}
          className="p-button-raised"
          loading={loading}
        />
      )}
      <Button
        label="Hủy"
        icon="pi pi-times"
        onClick={onCancel}
        className="p-button-raised p-button-secondary"
        loading={loading}
      />
    </>
  );

  const updateItem = (e, item) => {
    e.preventDefault();
    console.log(item);

    let list = _.cloneDeep(item.listArea);
    // console.log(list);
    let area = [];
    list.forEach((ar) => {
      area.push(ar.id);
    });

    setItem({ ...item, area: area });
    setVisible(true);
  };

  const deleteItem = (e, Id) => {
    e.preventDefault();
    // console.log(id);
    Swal.fire({
      title: "Thông báo",
      text: "Bạn có chắc chắn muốn xóa suất này không ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Xác nhận",
      cancelButtonText: "Hủy",
    }).then((result) => {
      if (result.value) {
        setLoading(true);
        axiosWithHeaders("post", DEL_CHANNELS_PACKAGE, { Id })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.status === enums.RESPONSE_OK
            ) {
              const { status, message } = response.data;
              if (status === enums.RESPONSE_OK) {
                Swal.fire("Thông báo", "Xóa suất thành công", "success");
                
                if (typeof onReloadData === "function") onReloadData(eventId);
              } else {
                Swal.fire("Lỗi", message, "error");
              }
            }
          })
          .catch((err) => {
            Swal.fire("Lỗi", err.toString(), "error");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const cellTemplate = (row, column) => {
    const field = column.field;
    switch (field) {
      case "STT":
        return column.rowIndex + 1;
      case "areaName":
        let listArea = row.listArea;
        let name = [];
        if (listArea && listArea.length > 0) {
          listArea.forEach((area) => {
            name.push(area.name);
          });
        }
        return <>{name.join(", ")}</>;
      case "isDefault":
        return (
          <div className="d-flex justify-content-center">
            <InputSwitch checked={row[field]} disabled />
          </div>
        );
      default:
        return (
          <div
            style={{
              width: "100%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <Button
              icon="pi pi-pencil"
              className="p-button-success p-button-raised"
              style={{ marginRight: 7, width: 35 }}
              onClick={(e) => updateItem(e, row)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-danger p-button-raised"
              style={{ width: 35 }}
              onClick={(e) => deleteItem(e, row.id)}
            />
          </div>
        );
    }
  };

  return (
    <>
      <div className="row">
        <div
          className={`col-md-12 d-flex align-items-center position-relative justify-content-between`}
        >
          <div style={{ minWidth: 100 }}></div>
          <div style={{ fontSize: `1.5rem`, color: `red`, fontWeight: 700 }}>
            CÀI ĐẶT SUẤT
          </div>
          <div>
            <Button
              label="THÊM"
              icon="pi pi-plus"
              className="p-button-raised p-button-secondary"
              onClick={() => {
                setVisible(true);
                setItem(initData);
              }}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <DataTable
            value={data}
            scrollable={true}
            scrollHeight={"60vh"}
            rowGroupMode="rowspan"
            sortField="channelName"
            sortOrder={2}
            groupField="channelId"
            paginator={true}
            emptyMessage="Hoạt động này chưa tạo suất nào...."
            rows={25}
            rowsPerPageOptions={[25, 50, 100]}
          >
            <Column field="channelName" header="Kênh" />
            <Column field="name" header="Suất" />
            <Column
              field="areaName"
              header="Vùng"
              body={(row, column) => cellTemplate(row, column)}
            />
            <Column
              field="isDefault"
              header="Mặc định"
              body={(row, column) => cellTemplate(row, column)}
            />
            <Column
              body={(row, column) => cellTemplate(row, column)}
              style={{ width: 120 }}
              className={"p-col-fixed"}
            />
          </DataTable>
        </div>
      </div>
      <Dialog
        header={item && item.id ? "CẬP NHẬT SUẤT" : "THÊM SUẤT"}
        footer={footer}
        visible={visible}
        style={{ width: "600px" }}
        modal={true}
        onHide={onCancel}
      >
        <div className="row mt-2">
          <div className="col-md-12">
            <Messages ref={refMessage}></Messages>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="lblName">Tên suất</label>
          </div>
          <div className="col-md-6">
            <InputText
              id="lblName"
              style={{ width: "100%" }}
              placeholder="Nhập tên suất..."
              onChange={(e) => setItem({ ...item, name: e.target.value })}
              // value={this.state.name}
              value={item && item.name ? item.name : ""}
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3 align-self-start text-right">
            <label htmlFor="lblDescription">Mô tả suất</label>
          </div>
          <div className="col-md-6">
            <InputTextarea
              id="lblDescription"
              rows={5}
              style={{ width: "100%" }}
              value={item && item.description ? item.description : ""}
              onChange={(e) =>
                setItem({ ...item, description: e.target.value })
              }
              placeholder="Nhập mô tả về suất..."
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="lblChannelName">Kênh</label>
          </div>
          <div className="col-md-6">
            <Dropdown
              inputId="lblChannelName"
              value={item && item.channelId ? item.channelId : ""}
              options={listChannel}
              onChange={(e) => {
                setItem({ ...item, channelId: e.value });
              }}
              filter={true}
              optionLabel="name"
              optionValue="id"
              filterPlaceholder="Tìm kênh"
              filterBy="id,name"
              style={{ width: "100%" }}
              placeholder="Chọn kênh"
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3 align-self-center text-right">
            <label htmlFor="lblArea">Vùng</label>
          </div>
          <div className="col-md-6">
            <MultiSelect
              value={item?.area ? item.area : []}
              options={listArea}
              onChange={(e) => {
                setItem({ ...item, area: e.value });
              }}
              filter={true}
              optionLabel="areaName"
              optionValue="areaId"
              filterPlaceholder="Tìm vùng"
              filterBy="label,value"
              style={{ width: "100%" }}
              placeholder="Chọn vùng"
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3 align-self-center text-right"></div>
          <div className="col-md-6">
            <Checkbox
              checked={item && item.isDefault ? item.isDefault : false}
              inputId={`chk-chanel-package`}
              onChange={(e) => setItem({ ...item, isDefault: e.checked })}
            ></Checkbox>
            <label htmlFor={`chk-chanel-package`} className="p-checkbox-label">
              &nbsp;Mặc định
            </label>
          </div>
        </div>
      </Dialog>
    </>
  );
}
